var _style, _path, _path2, _path3, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRidesumIconRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00C68E;}\n\t.st1{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M395,500H105"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M141.9,403.4c3.7,2.8,8.2,4.3,12.8,4.3c4-0.1,7.9-1.2,11.3-3.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105,0h290c58,0,105,47,105,105v290c0,58-47,105-105,105H105C47,500,0,453,0,395V105C0,47,47,0,105,0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M408.7,241.1c-1.7-3.1-4.1-5.8-7-7.8L286.4,160c-1.9-1.2-4.1-1.9-6.4-2c-2.3-0.1-4.6,0.4-6.6,1.5 c-2,1.1-3.7,2.6-4.9,4.6c-1.2,1.9-1.8,4.1-1.8,6.4V256c0.1,3.2,1.5,6.2,3.9,8.5c2.4,2.2,5.5,3.5,8.8,3.5c3.3,0,6.4-1.2,8.8-3.5 c2.4-2.2,3.8-5.3,3.9-8.5v-62.7l91.1,57.9L272.8,319c-2.3,1.4-4.1,3.6-5.1,6.1c-1,2.5-1.1,5.3-0.3,7.9c0.8,2.6,2.4,4.9,4.6,6.5 c2.2,1.6,4.9,2.5,7.6,2.5c2.4,0,4.8-0.7,6.8-2l114.8-70.5l0.5-0.3c4.4-3.1,7.6-7.6,8.9-12.8C411.8,251.2,411.2,245.8,408.7,241.1 L408.7,241.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M234.5,327.4l-46.9-51.5c13-2,25-8.3,34.1-17.8c9.9-10.6,14.9-24.3,14.9-40.5c0.2-10.9-2.6-21.7-8.1-31.2 c-5.3-9-13.1-16.4-22.5-21.2c-10.3-5.1-21.8-7.6-33.3-7.4H97.5c-1.1,0-2.3,0.2-3.3,0.6c-1,0.4-2,1.1-2.8,1.8 c-0.8,0.8-1.4,1.7-1.9,2.8c-0.4,1-0.7,2.1-0.7,3.3v166.7c0,1.1,0.2,2.3,0.6,3.3c0.4,1,1.1,2,1.9,2.8c1.6,1.6,3.9,2.5,6.2,2.5h8.6 c2.3,0,4.5-0.9,6.2-2.5c0.8-0.8,1.5-1.8,1.9-2.8c0.4-1,0.7-2.2,0.6-3.3V182.6h58.2c11.8,0,21.2,3.2,27.9,9.5 c6.7,6.3,10.1,14.7,10.1,25.7c0,10.9-3.3,19.2-10.1,25.5c-6.8,6.2-16.2,9.3-27.9,9.3h-26.3c-1.7-0.1-3.4,0.2-4.9,0.8 c-1.6,0.6-3,1.5-4.2,2.6c-1.2,1.1-2.2,2.5-2.8,4.1c-0.7,1.5-1,3.2-1,4.8s0.3,3.3,1,4.8c0.7,1.5,1.6,2.9,2.8,4.1 c1.2,1.1,2.7,2,4.2,2.6c1.6,0.6,3.2,0.9,4.9,0.8h8.9l55.5,61.7c0.8,0.9,1.8,1.6,2.9,2c1.1,0.5,2.3,0.8,3.5,0.7h10.6 c1.7,0,3.3-0.5,4.7-1.4c1.4-0.9,2.5-2.2,3.2-3.7c0.7-1.5,0.9-3.2,0.6-4.9c-0.3-1.6-1-3.2-2.2-4.4L234.5,327.4L234.5,327.4z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRidesumIconRounded);
export default __webpack_public_path__ + "static/media/ridesumIconRounded.7f65412edfbe043797d7f1377adef777.svg";
export { ForwardRef as ReactComponent };